module.exports = __webpack_public_path__ + "img/ISEEC_logo.1e719cbc.png";